import { getStorage, ref, listAll } from "firebase/storage"

const storage = getStorage()


export const guest_dp_list = async() => {
    const listRef = ref(storage, 'users/')
    let arr = []
    await listAll(listRef).then((res) => {
        res.prefixes.forEach((folderRef) => {
            arr.push(folderRef.name)
            // console.log("path is", folderRef.name)
        })
      
    })     
    return(arr)

}